import React, { createContext } from 'react'

// Opt-in field metadata for the "unsaved changes" UI
// (shared/sso-workspace/unsaved-changes.js). A page that wants it wraps its
// form in UnsavedChangesProvider, which provides UnsavedFieldsContext; every
// FormNewLabel inside then registers its field (label, section, whether its
// value is secret) and marks itself "Edited" while dirty. Pages without the
// provider are untouched.
export const UnsavedFieldsContext = createContext(null)

// The section a field sits in ({ id, title }), provided by WorkspaceSection.
export const FieldSectionContext = createContext(null)

// The plain text of a label that may be a React node (e.g. text plus a
// "Staff" tag, whose visually hidden text is skipped).
export const textOf = node => {
  if (node === null || node === undefined || typeof node === 'boolean') return ''
  if (typeof node === 'string' || typeof node === 'number') return String(node)
  if (Array.isArray(node)) return node.map(textOf).join('')
  if (React.isValidElement(node)) {
    const props = node.props || {}
    if (props['aria-hidden'] === 'true' || props['aria-hidden'] === true) return ''
    if (typeof props.className === 'string' && props.className.split(' ').includes('visually-hidden')) return ''
    return textOf(props.children)
  }
  return ''
}
